const OUTCOME_STYLES = {
  success: { bg: 'rgba(0,230,138,0.1)',  color: 'var(--olv-green)', label: 'ALLOWED' },
  denied:  { bg: 'rgba(255,178,36,0.1)', color: 'var(--olv-amber)', label: 'DENIED' },
  blocked: { bg: 'rgba(255,59,92,0.1)',  color: 'var(--olv-red)',   label: 'BLOCKED' },
  sealed:  { bg: 'rgba(0,212,255,0.1)',  color: 'var(--olv-cyan)',  label: 'SEALED' },
  error:   { bg: 'rgba(255,59,92,0.1)',  color: 'var(--olv-red)',   label: 'ERROR' },
}

export default function SeverityBadge({ outcome }) {
  const s = OUTCOME_STYLES[outcome] || OUTCOME_STYLES.success
  return (
    <span style={{
      display: 'inline-block', padding: '2px 8px', borderRadius: 'var(--olv-radius-chip)',
      fontSize: 9, fontFamily: 'var(--font-mono)', fontWeight: 600,
      letterSpacing: '0.06em', textTransform: 'uppercase',
      background: s.bg, color: s.color,
    }}>
      {s.label}
    </span>
  )
}
